"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateYardTransport = exports.CreateYardTransport = exports.YardTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const address_transport_1 = require("../common/address-transport");
exports.YardTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    isPrimary: typebox_1.Type.Boolean(),
    latitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    longitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    yardAddress: address_transport_1.AddressTransport,
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.CreateYardTransport = typebox_1.Type.Pick(exports.YardTransport, [
    'isPrimary',
    'name',
    'latitude',
    'longitude',
    'yardAddress',
]);
exports.UpdateYardTransport = typebox_1.Type.Pick(exports.YardTransport, [
    'isPrimary',
    'name',
    'latitude',
    'longitude',
    'yardAddress',
]);
//# sourceMappingURL=yard-transport.js.map